<mat-card class="card shadow-sm m-3">

  <mat-card-header>
    <mat-card-title>
      {{ph.name}} <span class="gray">- {{ph.skratka}}</span>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>

    <div class="me-3 ms-3 mb-3">

      <div class="row item-row" *ngFor="let h of zapocitavat(ph.items)">
          <div class="col-10 col-md">
            <span class="d-none d-md-block">{{h.popis}}</span>
            <div class="d-block d-md-none text-nowrap">{{h.popis}} <span  [ngClass]="{'red':maMaloBodov(h)}">{{getHranica(h)}}</span></div>
          </div>

          <div class="col text-center d-none d-md-block">
            <span [ngClass]="{'red':maMaloBodov(h)}">{{getHranica(h)}}</span>
          </div>

          <div class="col d-none d-md-block text-nowrap">{{h.zapisal}}</div>

          <div class="col-1 text-end text-nowrap">
            <span [ngClass]="{'red':maMaloBodov(h)}">{{getPocetBodov(h)}}</span>
          </div>
      </div>

      <div class="row sum-row">
        <div class="col-10 col-md">
          <span class="fw-bold text-nowrap" i18n>Body pre navrhované hodnotenia</span>
        </div>
        <div class="col-1 text-end text-nowrap">
          <span class="fw-bold">{{getPocetBodovSk(suma)}}</span>
        </div>
      </div>

      <div class="row item-row" *ngFor="let h of nezapocitavat(ph.items); first as isFirst" [ngClass]="{'mt-3':isFirst}">
        <div class="col-10 col-md">
          <span class="d-none d-md-block">{{h.popis}}</span>
          <div class="d-block d-md-none text-nowrap">{{h.popis}} <span  [ngClass]="{'red':maMaloBodov(h)}">{{getHranica(h)}}</span></div>
        </div>

        <div class="col text-center d-none d-md-block">
          <span [ngClass]="{'red':maMaloBodov(h)}">{{getHranica(h)}}</span>
        </div>

        <div class="col d-none d-md-block text-nowrap">{{h.zapisal}}</div>

        <div class="col-1 text-end text-nowrap">
          <span [ngClass]="{'red':maMaloBodov(h)}">{{getPocetBodov(h)}}</span>
        </div>
      </div>

    </div>

  </mat-card-content>
</mat-card>
